module.exports = __webpack_public_path__ + "media/Video 25b.f0237a16.mp4";